// extracted by mini-css-extract-plugin
module.exports = {"header":"popover-list-header__header___1n9Xw"};